module.exports = __webpack_public_path__ + "static/menu-Yoga-9ffe8d11aebdf14e17cb02d1746b880a.png";